/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser; currentUserInfo?: API.UserInfo } | undefined,
) {
  const { currentUserInfo } = initialState ?? {};
  return {
    canAdmin: currentUserInfo?.role === 2, // role 2 = 管理员
  };
}
